// Shake every visible [data-invalid="true"] element and move focus to the first one.
// Call it after the red state has rendered (e.g. in a short setTimeout after setState).
export const shakeInvalidFields = () => {
  const fields = [...document.querySelectorAll('[data-invalid="true"]')].filter(
    (el) => el.offsetParent !== null,
  )
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
  if (!reduceMotion) {
    fields.forEach((el) =>
      el.animate?.(
        [0, -6, 6, -4, 4, 0].map((x) => ({ transform: `translateX(${x}px)` })),
        { duration: 400 },
      ),
    )
  }
  const first = fields[0]
  if (!first) return
  first.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' })
  ;(first.matches('input') ? first : first.querySelector('input'))?.focus({ preventScroll: true })
}
